if (document.querySelector('.c-scrolling-images')) {
    gsap.to('.c-scrolling-images', {
        scrollTrigger: {
            trigger: '.c-scrolling-images__title',
            pin: true,
            pinSpacing: false,
            end: 'max'
        },
    });
}

document.querySelectorAll('.iconic_prints').forEach(parentElement => {
    if (parentElement.querySelector('.c-iconic-prints')) {
        gsap.to('.c-iconic-prints', {
            scrollTrigger: {
                trigger: '.c-iconic-prints',
                pin: true,
                pinSpacing: false,
                end: 'max',
                onEnter: () => {
                    parentElement.querySelector('.prints-bottom').classList.add('enter');
                }
            },
        });
    }
    if (parentElement.querySelector('.c-iconic-prints__swiper')) {
        const iconicPrintsSwiper = new Swiper(parentElement.querySelector('.c-iconic-prints__swiper'), {
            autoplay: {
                delay: 5000
            },
            speed: 3000,
            init: false,
            allowTouchMove: false
        });

        /**
         * @type {HTMLElement[]}
         */
        const bgs = [...parentElement.querySelectorAll('.c-iconic-prints__bg')];
        /**

         /**
         * @type {HTMLElement[]}
         */
        const printPrev = [...parentElement.querySelectorAll('.js-print-prev')];
        /**
         * @type {HTMLElement[]}
         */
        const printNext = [...parentElement.querySelectorAll('.js-print-next')];
        /**
         * @type {HTMLElement[]}
         */
        const progress = [...parentElement.querySelectorAll('.print-tab__progress')];

        const iconicContentPrintsSwiper = new Swiper(parentElement.querySelector('.prints-bottom'), {
            spaceBetween: 16,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: progress.length
                }
            },
            autoplay: {
                delay: 5000
            },
            speed: 3000,
            allowTouchMove: false
        });

        if (printNext.length > 0) {
            printPrev[printPrev.length - 1].style.opacity = '1';
            printNext[1].style.opacity = '1';
        }

        iconicPrintsSwiper.on('slideChange', () => {
            if (printNext.length > 0) {
                const prevIndex = iconicPrintsSwiper.activeIndex > 0 ? iconicPrintsSwiper.activeIndex - 1 : printPrev.length - 1;
                const nextIndex = iconicPrintsSwiper.activeIndex < printNext.length - 1 ? iconicPrintsSwiper.activeIndex + 1 : 0;
                const prev = printPrev[prevIndex];
                const next = printNext[nextIndex];
                printPrev.forEach(e => e.style.opacity = '0');
                printNext.forEach(e => e.style.opacity = '0');

                prev.style.opacity = '1';
                next.style.opacity = '1';

                if (bgs.length > 0) {
                    bgs.forEach(e => e.style.opacity = '0');
                    bgs[iconicPrintsSwiper.activeIndex].style.opacity = '1';
                }
            }

            if (iconicPrintsSwiper.activeIndex === 0) {
                progress.forEach(e => {
                    gsap.fromTo(e, { width: '100%' }, { width: 0, duration: .3, ease: 'linear' });
                });
            }
            gsap.fromTo(progress[iconicPrintsSwiper.activeIndex], { width: 0 }, {
                width: '100%',
                duration: 8,
                ease: 'linear'
            });
        });

        iconicPrintsSwiper.on('init', function () {
            gsap.fromTo(progress[0], { width: 0 }, { width: '100%', duration: 5, ease: 'linear' });
        });

        iconicPrintsSwiper.init();

        parentElement.querySelector('.prints-top').style.height = `${window.innerHeight - document.querySelector('.prints-bottom').getBoundingClientRect().height}px`;
        window.addEventListener('resize', () => {
            parentElement.querySelector('.prints-top').style.height = `${window.innerHeight - document.querySelector('.prints-bottom').getBoundingClientRect().height}px`;
        });
    }
});
